export interface ResponseWithMeta<T> {
    data: T;
    total: number;
    totalPages: number;
    page: number;
    limit?: number;
}
